module.exports = "/packs/media/images/intro-score-8f3937b7fb4bb13ed94b2bd6f0a15bec.png";